import { render, staticRenderFns } from "./AboutThree.vue?vue&type=template&id=c2c07bca&scoped=true&"
import script from "./AboutThree.vue?vue&type=script&lang=js&"
export * from "./AboutThree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c07bca",
  null
  
)

export default component.exports